import { ReactNode, useCallback } from 'react';
import classes from 'classnames';
import styles from 'components/BankCard/BankCard.module.scss';

type Props = {
  code?: string;
  children?: ReactNode;
  name?: string;
  className?: string;
  dataTest?: string;
  onClick?: (code?: string, name?: string) => void;
};

export default function BankCard({
  code,
  children,
  name,
  className,
  dataTest = 'bankCard',
  onClick,
}: Props) {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(code, name);
    }
  }, [code, name, onClick]);

  return (
    <div className={classes(styles.container, className)}>
      <button
        className={styles.button}
        data-test={dataTest}
        onClick={handleClick}
        type="button"
      >
        <div
          className={styles['logo-container']}
          data-test={`${dataTest}-content`}
        >
          {children}
        </div>
        {name && (
          <div className={styles.footer} data-test={`${dataTest}-footer`}>
            <span data-test={`${dataTest}-footer-name`}>{name}</span>
          </div>
        )}
      </button>
    </div>
  );
}
